import { get, set, del } from 'idb-keyval';

export const loadFromLocalStorage = <T>(key: string): T | undefined => {
  const data = localStorage.getItem(key);
  if (data) {
    try {
      const parsedData = JSON.parse(data) as any;

      // Remove the `_persist` key if it exists
      if ('_persist' in parsedData) {
        delete parsedData._persist;
      }

      // Iterate over the keys and JSON-parse each value
      for (const [key, value] of Object.entries(parsedData)) {
        if (typeof value === 'string') {
          try {
            parsedData[key] = JSON.parse(value);
          } catch {
            // If parsing fails, keep the original value
            console.warn(`Failed to parse key "${key}" in localStorage data.`);
          }
        }
      }

      localStorage.removeItem(key); // Clean up the old localStorage entry

      return parsedData;
    } catch (error) {
      console.error(`Failed to parse localStorage key "${key}":`, error);
    }
  }
  return undefined;
};

localStorage.removeItem('persist:root'); // Clean up the old localStorage entry

// Custom storage engine for redux-persist using idb-keyval
const idbStorage = {
  getItem: async (key: string) => {
    const value = await get(key);
    return value ? JSON.stringify(value) : null; // Return as a JSON string to match redux-persist's expectations
  },
  setItem: async (key: string, value: string) => {
    await set(key, JSON.parse(value)); // Parse the JSON string before storing
  },
  removeItem: async (key: string) => {
    await del(key);
  },
};

export default idbStorage;
